export enum FormEndAdornmentTypes {
  Clear = "clear",
}
